const binding = { modules: {}, dataActions: {} };

    (binding.modules['cz-sign-up'] = {
        c: () => require('partner/modules/cz-sign-up/cz-sign-up.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cz-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cz-sign-up'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|cz-sign-up|cz-sign-up'] = {
                c: () => require('partner/modules/cz-sign-up/cz-sign-up.view.tsx'),
                cn: '__local__-__local__-cz-sign-up'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };